// extracted by mini-css-extract-plugin
export default {"container":"styles_container__UYWue","item1":"styles_item1__7SPSb","item2":"styles_item2__Fv4VA"};